// pages/GetQuote.js
import React from "react";
import GetQuoteImage from '../images/get-quote.jpeg';
import Navmain from '../main/header';
import Footer from '../main/footer';
import GetQuote from '../main/GetQuote';

function GetQuotePage() {
  return (
    <div>
      <Navmain />
      <main className="main">
        <section className="bg-home9 no-gutters">
          <div className="container d-flex justify-content-center align-items-center">
            <div className="row w-100">
              <div className="col-6 d-none d-lg-block p-2">
                <div className="border-0 rounded login-content" style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                  <img
                    className="form-image"
                    src={GetQuoteImage}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                    alt="Get Quote"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-12" style={{minHeight:'520px'}}>
                <GetQuote />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default GetQuotePage;
